/**
 * @ngdoc config
 * @memberof mercury.startup
 * @name AllSettledConfig
 * @description Config to extend $q with an implementation of `allSettled` to
 *   allow a set of independent promises to be awaited. This differs from the
 *   inbuilt `all` method which will immediately reject when any of the
 *   inner promises reject.
 *
 *   Credit to https://stackoverflow.com/a/27114615 for the implementation.
 */
angular.module('mercury.startup').config(['$provide', function($provide) {
  $provide.decorator('$q', ['$delegate', function($delegate) {
    var $q = $delegate;

    $q.allSettled = $q.allSettled || function allSettled(promises) {
      // Implementation of allSettled function from Kris Kowal's Q:
      // https://github.com/kriskowal/q/wiki/API-Reference#promiseallsettled

      function wrap(promise) {
        return $q.when(promise)
          .then(function(value) {
            return {state: 'fulfilled', value: value};
          }, function(reason) {
            return {state: 'rejected', reason: reason};
          });
      }

      var wrapped = angular.isArray(promises) ? [] : {};
      angular.forEach(promises, function(promise, key) {
        if (!wrapped.hasOwnProperty(key)) {
          wrapped[key] = wrap(promise);
        }
      });

      return $q.all(wrapped);

    };

    return $q;
  }]);
}]);
